export const novias = () => {
  return [
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n1_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n1_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n1_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n1_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n2_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n2_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n2_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n2_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n3_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n3_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n3_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n3_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n4_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n4_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n4_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n4_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n5_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n5_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n5_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n5_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/n6_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/n6_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n6_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/n6_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    }
  ]
}
